// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"48ecece5","235":"084325ee","264":"5902ede3","328":"344949be","389":"48ecece5","671":"18d71b2a","826":"07638020"}[chunkId] + ".chunk.css";
};